import React, { useMemo } from "react";
import SectionContent from "./SectionContent";
import { McTable } from "@maersk-global/mds-react-wrapper/components-core/mc-table";

const METRICS = [
  {
    key: "mttd",
    name: "Mean Time To Detect",
    description:
      "Time between the problem first occurring, and when it was detected (by human or automation)",
  },
  {
    key: "mttrespond",
    name: "Mean Time To Respond",
    description:
      "Time between the issue being detected and an engineer beginning investigations.",
  },
  {
    key: "mttrepair",
    name: "Mean Time To Repair",
    description:
      "Time between the engineer investigation starting and service being restored.",
  },
  {
    key: "mttrecover",
    name: "Mean Time To Recover",
    description:
      "Time between the problem first occurring and service being restored.",
  },
];

const MTT_COLUMNS = [
  { id: "metric", label: "Metric", noWrap: true },
  { id: "description", label: "Description" },
  {
    id: "value",
    label: "Value (minutes)",
    cellTemplate: (e) => {
      const val = e.rowData.value;
      if (val !== null && val !== undefined) {
        return e.html`<span style="font-weight: 600; font-size: 14px; color: var(--mds_brand_appearance_primary_default_text-color, #0073ab);">${val}</span>`;
      }
      return e.html`<em style="font-size: 12px; color: #141414;">Please fill this on edit page</em>`;
    },
  },
];

function DetectionAndResponseSection({ data, images, requiredForModal }) {
  const tableData = useMemo(
    () =>
      METRICS.map((m) => ({
        id: m.key,
        metric: m.name,
        description: m.description,
        value: data?.[m.key] ?? null,
      })),
    [data]
  );

  return (
    <div id="detection-and-response">
      {data?.description && data.description.trim() !== "" && (
        <SectionContent
          sectionData={data.description}
          images={[]}
          requiredForModal={requiredForModal}
        />
      )}
      <div style={{ marginTop: "12px" }}>
        <McTable data={tableData} columns={MTT_COLUMNS} fit="small" />
      </div>
      {images && images.length > 0 && (
        <div className="report-images">
          {images.map((image, index) => (
            <img key={index} alt={image.name} src={image.preview} />
          ))}
        </div>
      )}
    </div>
  );
}

export default DetectionAndResponseSection;
